import { CheckoutServiceMvp } from '../../../../../services/CheckoutMvp';
import { EGerdauService } from '../../../../../services/EGerdauService';
import { CookiesKey } from '../../../../../services/MVP/enum';
import { deleteCookie } from '../../../../../services/MVP/utils';
import { IOrderSimulateState } from '../../../../../store/ducks/order-simulate-checkout-mvp/types';
import { v4 as uuidv4 } from 'uuid';

export const useCheckoutMvp = () => {
  const service = new CheckoutServiceMvp();

  const deleteCartId = () => {
    EGerdauService.setCorrelationId(uuidv4());
    deleteCookie(CookiesKey.CART_ID);
    deleteCookie(CookiesKey.EMITTER_ID);
  };

  const getCheckoutFromLocalStorage = () => {
    const checkoutState: IOrderSimulateState =
      service.getCheckoutFromLocalStorage();
    return checkoutState;
  };

  const updateCheckoutLocalStorage = (checkoutState: IOrderSimulateState) => {
    service.updateCheckoutStateLocalStorage(checkoutState);
  };

  return {
    deleteCartId,
    getCheckoutFromLocalStorage,
    updateCheckoutLocalStorage
  };
};
